import { SVGPureIcon } from '@/ui';
// import './index.scss';
import globalStore from '@/store/global';

function BackBottomButton(props) {
  const { className, onClick } = props;
  return (
    <button
      className={[
        'size-32px rounded-full cursor-pointer flex justify-center items-center',
        'border-1px ',
        globalStore.isDark ? 'bg-[#3D3D46] hover:bg-[#505058] border-[rgba(255,255,255,0.1)]':'bg-[#fff] hover:bg-[#F6F7F9] border-[rgba(0,0,0,0.1)]',
        className,
      ]}
      onClick={event => onClick?.(event)}
    >
        <SVGPureIcon name="back_bottom" className={`size-16px ${globalStore.isDark ? 'text-[#fff]':'text-[#000]'}`} />
    </button>
  );
}

export default BackBottomButton;
